import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="py-16 md:py-24 px-4 relative" data-id="element-82">
      <div className="max-w-4xl mx-auto text-center" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-84">
          <span className="text-sm font-bold tracking-widest text-warm uppercase mb-4 block" data-id="element-85">
            La Revelación
          </span>

          <p className="text-lg md:text-xl text-muted mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-86">
            La mayoría de los expertos te dicen que "pienses en positivo" o que
            medites una hora por día. Seamos realistas: si pudieras calmarte
            pensando, ya lo habrías hecho.
          </p>

          <div className="py-8 md:py-12" data-id="element-87">
            <h3 className="text-2xl md:text-4xl font-serif font-bold text-main leading-relaxed md:leading-relaxed max-w-3xl mx-auto" data-id="element-88">
              La ansiedad no se resuelve con la mente,{' '}
              <br className="hidden md:block" data-id="element-89" />
              <span className="text-warm underline decoration-warm/30 underline-offset-8" data-id="element-90">
                se resuelve con el cuerpo.
              </span>
            </h3>
          </div>

          <div className="mt-12 pt-12 border-t border-white/10" data-id="element-91">
            <p className="text-muted mb-4" data-id="element-92">Presentamos:</p>
            <h2 className="text-4xl md:text-6xl font-serif font-bold text-main mb-8 tracking-wide" data-id="element-93">
              MENTE EN CALMA
            </h2>
            <p className="text-lg md:text-xl text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-94">
              Un sistema práctico de 7 días que usa la neurociencia y el
              biohacking para enviarle una señal química a tu cerebro de que el
              peligro ha pasado. Sin vueltas. Sin teoría aburrida. Solo
              protocolos que funcionan en 5 minutos o menos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}